const SET = 'asideState.SET';

const defaultState = {
 menu : false,
  tab : 'home' //course, topic
};

const set = data => ( { type : SET, data : data } );

const asideState = ( state=defaultState, action ) => {

  switch ( action.type ) {
    case SET :
      return { ...state, ...action.data };
    default :
      return state;
  }

};

export default asideState;
export { set };
